"use client";

import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: "t1",
  author: "Sarah J.",
  quote: "Our Airbnb has never looked better. The turnover service is seamless and our guests always comment on how sparkling the home feels!",
  position: "Airbnb Host, Vero Beach"
}, {
  id: "t2",
  author: "Mark T.",
  quote: "Reliable, professional, and always on time. They handle our commercial office space with incredible care. It's the best cleaning service in town.",
  position: "Business Owner"
}, {
  id: "t3",
  author: "Emily R.",
  quote: "I love that they use eco-friendly products. My home smells fresh without any harsh chemicals, and the team is always so friendly and helpful.",
  position: "Residential Client"
}, {
  id: "t4",
  author: "David L.",
  quote: "Their move-out cleaning service saved us so much time and stress. The house looked better than when we moved in! Highly recommend Coastal Cleaning.",
  position: "Indian River Shores"
}, {
  id: "t5",
  author: "Michelle K.",
  quote: "The most thorough cleaning I've ever had. They don't just surface clean; they get into every corner. Our home feels like a sanctuary again.",
  position: "Orchid Island Resident"
}, {
  id: "t6",
  author: "Robert H.",
  quote: "Managing a property from afar is tough, but Coastal Cleaning makes it easy. I trust them implicitly with my home and my guests' comfort.",
  position: "Seasonal Resident"
}];
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222466" id="vero-beach-voices" className="relative w-full overflow-hidden bg-background py-24 md:py-32 text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden opacity-[0.03] select-none">
        <span className="font-default text-[25vw] font-bold leading-none text-foreground whitespace-nowrap">
          VERO BEACH
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 max-w-7xl">
        <div ref={headerRef} className={`mb-16 text-center transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
            Vero Beach Voices
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground">
            See why homeowners and property managers across the Treasure Coast trust Coastal Cleaning.
          </p>
        </div>

        <div ref={gridRef} className={`columns-1 gap-6 space-y-6 md:columns-2 lg:columns-3 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {testimonials.map((testimonial, i) => <div key={testimonial.id} data-index={i} className="break-inside-avoid">
              <Card className="h-full bg-card/90 backdrop-blur-sm border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300 rounded-xl">
                <CardContent className="flex flex-col gap-6 p-8">
                  <div className="flex gap-1 text-accent">
                    {[...Array(5)].map((_, j) => <Star key={j} className="h-5 w-5 fill-current" />)}
                  </div>
                  
                  <p className="font-serif text-xl italic leading-relaxed text-foreground">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="mt-auto pt-6 border-t border-border/40">
                    <p className="font-default text-lg font-bold text-foreground">
                      {testimonial.author}
                    </p>
                    <p className="font-default text-sm text-muted-foreground">
                      {testimonial.position}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}